import { render } from "./editOrder.vue?vue&type=template&id=64b60118&ts=true"
import script from "./editOrder.vue?vue&type=script&lang=ts"
export * from "./editOrder.vue?vue&type=script&lang=ts"

import "./editOrder.vue?vue&type=style&index=0&id=64b60118&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__